export default __webpack_public_path__ + "static/media/mayowa_phone.59d2bb03.jpg";